module.exports = __webpack_public_path__ + "static/media/grayskull-blog.b8a42ed7.md";